module.exports = __webpack_public_path__ + "static/media/blog2.427d8d68.png";